// Event names per "Funding Souq — Web Analytics Event Specification (OpenPanel)" §8.
// Do not rename: OpenPanel funnels/charts and the backend server-side events
// (deposit_request_completed, deposited_approved, investment_completed) rely on these.
export const OpenPanelEvents = {
	homeViewed: 'home_viewed',
	pageViewed: 'page_viewed',
	getStartedClicked: 'getstarted_clicked',
	signupStarted: 'signup_started',
	eCheckerVisited: 'e_checker_visited',
	eCheckerCompleted: 'e_checker_completed',
	investorTermsViewed: 'investor_terms_viewed',
	investorTierSelected: 'investor_tier_selected',
	kycStarted: 'kyc_started',
	personalInformationCompleted: 'personal_information_completed',
	documentsUploaded: 'documents_uploaded',
	declarationAccepted: 'declaration_accepted',
	opportunitiesViewed: 'opportunities_viewed',
	opportunitiesDetailsViewed: 'opportunities_details_viewed',
	depositRequestViewed: 'deposit_request_viewed',
	surveySubmitted: 'survey_submitted',
	borrowerSignupCompleted: 'borrower_signup_completed',
	nafathCompleted: 'nafath_completed',
	absherCompleted: 'absher_completed',
	businessInformationCompleted: 'business_information_completed',
	declarationViewed: 'declaration_viewed',
	makePaymentClicked: 'make_payment_clicked',
	appStoreButtonClicked: 'app_store_button_clicked',
	googlePlayButtonClicked: 'google_play_button_clicked',
};

// Funnel-stage grouping passed as the `category` event property (docx §4.3).
export const OpenPanelCategories = {
	onboarding: 'onboarding',
	kyc: 'kyc',
	opportunities: 'opportunities',
	checkout: 'checkout',
};
